// extracted by mini-css-extract-plugin
export default {"item":"Item_item__WA7Gi","selectedItem":"Item_selectedItem__nViYr","doneItem":"Item_doneItem__Oo98G","done":"Item_done__gml-I"};